import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { useForm } from "react-hook-form";
import { loginCreation } from "services/login";

export default function Login() {
  const history = useHistory();
  const { register, handleSubmit, reset, errors } = useForm();
  const { addToast } = useToasts();

  async function handleLogin(data) {
    data.id = "d0314b4e-6189-45c2-8f01-3aafb4a949b4";
    data.code = "SYS";
    data.prm = 3;

    try {
      const { data: loginData } = await loginCreation(data);
      console.log(loginData);
      if (loginData.success === 0) {
        addToast(loginData.message, {
          appearance: "error",
          autoDismiss: true,
        });
        reset();
      } else {
        addToast("Successfully Logged In", {
          appearance: "success",
          autoDismiss: true,
        });
        localStorage.setItem("token", loginData.data.token);

        setTimeout(() => {
          window.location.href = "/admin/dashboard";
        }, 3000);
      }
    } catch (error) {
      addToast("Internal Serval Error", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  }

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h6 className="text-gray-600 text-sm font-bold">
                    Sign in with Name
                  </h6>
                </div>
                <hr className="mt-6 border-b-1 border-gray-400" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <div className="text-gray-500 text-center mb-3 font-bold">
                  <small>Don't Have an account contact Admin</small>
                </div>
                <form>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Name"
                      name="name"
                      ref={register({ required: "Name is required" })}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      name="password"
                      ref={register({ required: true, minLength: 6 })}
                    />
                  </div>
                  {/* <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox text-gray-800 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                        ref={register({ required: true, minLength: 6 })}
                      />
                      <span className="ml-2 text-sm font-semibold text-gray-700">
                        Remember me
                      </span>
                    </label>
                  </div> */}

                  <div className="text-center mt-6">
                    <button
                      className="bg-green-400 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleSubmit(handleLogin)}
                    >
                      Sign In
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="flex flex-wrap mt-6 relative">
              <div className="w-1/2">
                <a
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                  className="text-gray-300"
                >
                  <small>Forgot password?</small>
                </a>
              </div>
              {/* <div className="w-1/2 text-right">
                <Link to="/auth/register" className="text-gray-300">
                  <small>Create new account</small>
                </Link>
              </div> */}
            </div>

            {errors.password && errors.password.type === "minLength" && (
              <li className="text-white">
                Password must be more than 6 characters
              </li>
            )}
            {errors.name && errors.name.type === "required" && (
              <li className="text-white">{errors.name.message}</li>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
